/**
 * Preferencias de los campos de cualificación: en qué orden se ven en la ficha del lead
 * y cuáles se asoman en las tarjetas del tablero.
 *
 * Hoy viven en el navegador; mañana en la cuenta, para que la configuración viaje con el
 * usuario y la vea todo el equipo. Toda la pantalla pasa por estas funciones y son
 * `async` a propósito: el día que exista el endpoint sólo cambia este fichero y nadie
 * más se entera.
 *
 * Las dos guardan una lista de claves de campo. Las claves que ya no existen se ignoran
 * al leer, así que tocar el cualificador no rompe lo guardado.
 */

const KEYS = {
    order: 'lixsa.pipeline.leadFieldOrder',
    card: 'lixsa.pipeline.cardFields',
};

const storageKey = (prefix, accountId) => `${prefix}.${accountId || 'anon'}`;

const readList = (prefix, accountId) => {
    try {
        const raw = window.localStorage.getItem(storageKey(prefix, accountId));
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed.filter((key) => typeof key === 'string') : [];
    } catch (error) {
        // localStorage puede no estar (Safari en privado, cookies bloqueadas): sin nada
        // guardado la pantalla sigue funcionando con los valores por defecto.
        console.warn('No se pudieron leer las preferencias de campos del lead:', error);
        return [];
    }
};

const writeList = (prefix, accountId, list) => {
    try {
        window.localStorage.setItem(storageKey(prefix, accountId), JSON.stringify(list || []));
        return true;
    } catch (error) {
        console.warn('No se pudieron guardar las preferencias de campos del lead:', error);
        return false;
    }
};

/** Orden de los campos en la ficha del lead, de arriba abajo. */
export async function loadLeadFieldOrder(accountId) {
    return readList(KEYS.order, accountId);
}

export async function saveLeadFieldOrder(accountId, order) {
    return writeList(KEYS.order, accountId, order);
}

/** Campos que se asoman en las tarjetas del tablero, en el orden en que se pintan. */
export async function loadCardFields(accountId) {
    return readList(KEYS.card, accountId);
}

export async function saveCardFields(accountId, keys) {
    return writeList(KEYS.card, accountId, keys);
}

export default { loadLeadFieldOrder, saveLeadFieldOrder, loadCardFields, saveCardFields };
